import styled from "styled-components";

export const FieldTip = styled.div`
  font-size: 0.9rem;
  color: #0f4059;
`;
